import SaleStatus from './index'

export default class NowOnSale implements SaleStatus {
  get isOnSale(): boolean {
    return true
  }
}
